import { toast } from "sonner";
import { createHttpClient } from "./createHttpClient";

const baseURL = process.env.NEXT_PUBLIC_API_BASE_V2 ?? "";

const client = createHttpClient({
  baseURL,
  withNoAuthClient: true,
  errors: {
    onResponseError: (message: string) => toast.error(message),
    onNetworkError: () => toast.error("Le serveur n'est pas joignable...!"),
    onSetupError: () => toast.error("Impossible d'envoyer la requete...!"),
  },
});

export const apiRequest = client.apiRequest;
export const axiosInstance = client.axiosInstance;
export const noAuthAxiosInstance = client.noAuthAxiosInstance;
export const fetcher = client.fetcher;
export const fetcherV2 = fetcher;
export const ensureAccessToken = client.ensureAccessToken;
